(function () {
  'use strict';

  angular.module('app').component('debitNoteList', debitNoteList());

  function debitNoteList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        onShowItem: '&',
      },
      controller: DebitNoteListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/debit-notes/debit-note-list/debit-note-list.component.html',
    };
  }

  DebitNoteListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'SessionService',
    'moment',
    'DebitNoteService',
    'DocumentService',
  ];

  function DebitNoteListComponent(
    config,
    UtilService,
    AbilityService,
    SessionService,
    moment,
    DebitNoteService,
    DocumentService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_debitnote_accountadmin'),
      canUpdate: AbilityService.can('update_debitnote_accountadmin'),
      canDestroy: AbilityService.can('destroy_debitnote_accountadmin'),
    };

    vm.debitNoteStatuses = angular.copy(config.CREDIT_NOTES_STATUSES);
    vm.debitNoteStatuses.unshift({
      label: 'ALL',
      value: null,
    });

    vm.atvCrStatuses = [...config.ATV_CR_STATUSES];
    vm.atvCrStatuses.unshift({
      label: 'ALL',
      value: null,
    });

    vm.statusDraft = 'draft';
    vm.statusProcessed = 'processed';
    vm.statusAccepted = 'accepted';
    vm.statusSent = 'sent';

    const apiUrl = 'debit_note_reports';
    vm.urlXls = apiUrl + '/export_debit_notes_xls.xlsx';
    vm.urlPdf = apiUrl + '/export_debit_notes_pdf.pdf';
    vm.reportName = 'debit_notes_report';

    // private properties
    // -----------------------
    let userLanguageCode = SessionService.getUserLanguage().code;
    const dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
    // const dateDisplay = config.DATE_DISPLAY_SHORT;

    const company = SessionService.getSelectedAccountCompany();

    vm.$onInit = function () {
      vm.atvCrEnabled = company.atv_cr_enabled;

      setDebitNotes(vm.items);

      setDefaultFilters();

      setDocumentDatePicker();
    };

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.loadingItems = true;
      DebitNoteService.getDebitNotes(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        setDebitNotes(vm.items);

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;
      });
    };

    vm.refresh = function () {
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      vm.fetchResult();
    };

    vm.showItem = function (item, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowItem({ item: item, mode: mode });
    };

    vm.deleteItem = function (item) {
      if (!vm.permissions.canDestroy) return;

      DebitNoteService.deleteDebitNote(item, vm.fetchResult());
    };

    // Atv functions
    vm.resendDocumentToAtv = function (item) {
      if (!item.canResend) return;

      vm.loadingDocument = true;
      DocumentService.resendDocumentToAtv(item, 'debit_notes').then(function (data) {
        if (data) {
          item.atv_status = data.atv_status;
          validateItemActions(item);
        }

        vm.loadingDocument = false;
      });
    };

    vm.notifyDocumentToClient = function (item) {
      if (!item.canNotify) return;

      const successCallBack = function (email) {
        item.client_email_receipt = email;

        vm.loadingDocument = true;
        DocumentService.notifyDocumentToClient(item, 'debit_notes', email).then(function () {
          vm.loadingDocument = false;
        });
      };

      DocumentService.openNotifyDocumentToClient(
        item.client.email,
        successCallBack,
        'SEND_DEBIT_NOTE_TO_CLIENT'
      );
    };

    vm.openRelatedTransactions = function (item) {
      DebitNoteService.openRelatedTransactions(item, item.client);
    };

    vm.clearDocumentDate = function () {
      vm.documentDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_date_from;
      delete vm.filterCriteria.by_date_to;

      vm.UtilService.filterResult();
    };

    vm.clearSearch = function () {
      setDefaultFilters();

      vm.fetchResult();
    };

    // private methods
    // -----------------------
    function setDebitNotes(items) {
      vm.sum_accounting_total = 0;
      items.forEach((item) => {
        vm.sum_accounting_total += item.accounting_grand_total;
        vm.base_currency_symbol = item.base_currency_symbol;
        item.date = moment(item.date).format(dateDisplay);
        item.debit_note_number = item.debit_note_number || '-';
        item.client_name = item.client.name + ' ' + item.client.last_name;

        validateItemActions(item);
      });
    }

    function validateItemActions(item) {
      item.canEdit =
        vm.permissions.canUpdate &&
        (item.status === 'draft' || item.document_type.numbering_type !== 'electronic');
      item.canDelete = vm.permissions.canDestroy && item.status === 'draft';
    }

    function setDefaultFilters() {
      vm.documentDatePicker = {
        // startDate: '',
        // endDate: '',
        startDate: vm.UtilService.startOfMonth(),
        endDate: vm.UtilService.today(),
      };

      vm.filterCriteria = DebitNoteService.getFilterCriteria();

      vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
        vm.UtilService.startOfMonth()
      );

      vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

      // vm.filterCriteria.by_status = vm.debitNoteStatuses[0].value;
      // vm.filterCriteria.by_atv_status = vm.atvCrStatuses[0].value;
    }

    function setDocumentDatePicker() {
      let filterByDocumentDate = () => {
        vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
          vm.documentDatePicker.startDate
        );

        vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.documentDatePicker.endDate);

        vm.UtilService.filterResult();
      };

      vm.documentDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDocumentDate,
        rangeOptions: config.DOCUMENT_DATE_OPTIONS,
        dateDisplay: dateDisplay,
      });
    }
  }
})();

// vm.filterCriteria.by_date_to = moment(
//   vm.UtilService.startOfDayFormat(vm.documentDatePicker.endDate)
// ).add(1, 'days');
